import { useQuery } from '@tanstack/react-query';
import { fetchModules } from '../fetchers/modules';
import { isModuleEnabled } from './moduleGate';

/*
 * The modules a customer has bought, from /api/modules.
 *
 * Modules and feature flags are two different things: a feature flag switches behaviour inside
 * a product, a module is a product part. This is the modules half, and it mirrors
 * useFeatureFlags so the two read the same way at a call site.
 *
 * The query key is ["module"] — the same key the four ad-hoc useQuery calls in Sidebar,
 * MachineDetails, machineTabs and activities already use — so every reader shares one request
 * rather than each opening its own.
 */
const useModules = () => {
  return useQuery({
    queryKey: ['module'],
    queryFn: () => fetchModules(),
    staleTime: 120000,
    refetchInterval: 120000
  });
};

// Re-exported so a call site has one import path for both halves, the way useFeatureFlags
// exports isFeatureEnabled. It is defined in moduleGate.js so it can be unit tested — see
// the note there.
export { isModuleEnabled };

export default useModules;
